import { Modal } from 'antd';
import React from 'react';
import { RichText } from 'prismic-reactjs';
import Exclamacion from '../../assets/images/exclamation.svg';

export default function ModalFire({ info, onClose }) {

    const _onCancel = () => {
        onClose();
    }

    return info && (
        <Modal
            title=""
            visible={true}
            footer=''
            onCancel={_onCancel}
            wrapClassName='modal-home'
        >
            <div className='modal-home-content'>
                <div className='modal-home-content-left'>
                    <div className='modal-home-content-left__body'>
                        <div className='modal-home-content-left__body-title'>
                            {info.modalicon && info.modalicon.url && (
                                <img src={info.modalicon.url} alt={info.modaltitle} />
                            )}
                            <p>{info.modaltitle || ''}</p>
                        </div>
                        <p className='modal-home-content-left__body-subtitle'>{info.modaldescription || ''}</p>
                        <ul className='modal-home-content-left__body-list'>
                            {info.modalitems && info.modalitems.length > 0 && info.modalitems.map((modalitem) =>
                                modalitem && modalitem.text && (<li>
                                    <em className='fal fa-check' />
                                    <div className='modal-home-content-left__body-list-description'>
                                        <strong>{modalitem.text.split('\n')[0]}</strong>
                                        <p> {modalitem.text.split('\n')[1]} </p>
                                    </div>
                                </li>)
                            )}
                        </ul>
                        {info.bottomcontent && info.bottomcontent.length > 0 && (<div className='modal-home-content-left__body-source'>{info.bottomcontent[0].text || ''}</div>)}
                    </div>
                </div>
                <div className='modal-home-content-right'>
                    {info.modalsidecontent && info.modalsidecontent.length > 0 && (<div className='modal-home-content-right__body'>
                        <p className='modal-home-content-right__body-title'>
                            <RichText
                                render={[info.modalsidecontent[0]]}
                            />
                        </p>
                        <div className='modal-home-content-right__body-description'>
                            <div className='modal-home-content-right__body-description-title'>
                                <img src={Exclamacion} alt='Imagen exclamación sabias que' />
                                <strong>{info.modalsidecontent[1].text}</strong>
                            </div>
                            <p>
                                {info.modalsidecontent.map((sideCont, index) =>
                                    index > 1 && (<>
                                        <p>{sideCont.text || ''}</p>
                                    </>)
                                )}
                            </p>
                        </div>
                    </div>)}
                </div>
            </div>
        </Modal>
    )
}